import {gsap} from "gsap";

export class ButtonMenu {
    constructor({el, onClick}) {
        this.DOM = {el};
        this.DOM.lines = this.DOM.el.querySelectorAll('.js-header_btnMenu_btn_line');
        this.onClick = onClick;
        this.isOpen = false;
        this.isReadyClick = true;
        this.bindEvent();
    }

    eventClick() {

        if (!this.isReadyClick) return;
        this.isReadyClick = false;

        this.onClick();
        if (this.isOpen) {
            this.closeAnimation();
        } else {
            this.openAnimation();
        }

        this.isOpen = !this.isOpen;
    }

    openAnimation() {
        gsap.to(this.DOM.lines[0], {y: 4, ease: 'power3.out', duration: .5, rotate: '45deg'});
        gsap.to(this.DOM.lines[1], {y: -4, ease: 'power3.out', duration: .5, rotate: '-45deg'});
        setTimeout(() => this.isReadyClick = true, 500);
    }

    closeAnimation() {
        gsap.to(this.DOM.lines[0], {y: 0, ease: 'power3.out', duration: .5, rotate: '0deg'});
        gsap.to(this.DOM.lines[1], {y: 0, ease: 'power3.out', duration: .5, rotate: '0deg'});
        setTimeout(() => this.isReadyClick = true, 500);
    }

    bindEvent() {
        this.DOM.el.addEventListener('click', this.eventClick.bind(this));
    }
}